import { useMemo, useState } from "react";
import { feedItems, feedTabs } from "@/mocks/homeContent";
import { useReveal } from "@/hooks/useReveal";

export default function LatestFeed() {
  const [activeTab, setActiveTab] = useState("all");
  const { ref, visible } = useReveal<HTMLDivElement>(0.1);

  const items = useMemo(() => {
    if (activeTab === "all") {
      return feedItems;
    }
    return feedItems.filter((item) => item.group === activeTab);
  }, [activeTab]);

  return (
    <section id="latest" className="w-full bg-background-50 py-14 md:py-20">
      <div
        ref={ref}
        className={`mx-auto w-full px-4 md:px-8 ${visible ? "reveal is-visible" : "reveal"}`}
      >
        <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <span className="h-4 w-1 rounded-full bg-primary-500" />
              <span className="text-xs font-medium tracking-[0.18em] text-secondary-600">
                TODAY UPDATE
              </span>
            </div>
            <h2 className="font-heading mt-3 text-2xl font-bold text-foreground-950 md:text-4xl">
              今日更新
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              按更新时间排序的合集条目，会员可见的完整版会标注专属标识，普通条目可直接阅读。
            </p>
          </div>

          <div className="flex flex-wrap gap-1 rounded-full bg-background-100 p-1">
            {feedTabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab.id)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  activeTab === tab.id
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:text-primary-600"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {items.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-[200px] w-full overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} 黑料福利专题合集`}
                  className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute left-3 top-3 flex items-center gap-2">
                  <span className="rounded-full bg-background-50/95 px-3 py-1 text-xs font-medium text-foreground-800">
                    {item.tag}
                  </span>
                  {item.hot && (
                    <span className="flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                      <i className="ri-fire-line" /> 热
                    </span>
                  )}
                </div>
              </div>

              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">
                  {item.excerpt}
                </p>

                <div className="mt-auto flex items-center justify-between pt-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" /> {item.time}
                  </span>
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line" /> {item.reads}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line" /> {item.comments}
                    </span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <button
            type="button"
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            加载更多更新
            <i className="ri-arrow-down-line" />
          </button>
        </div>
      </div>
    </section>
  );
}